import { useMemo } from "react";
import Loading from "../../components/Loading";
import { useSearchBarState } from "../../components/SearchBarProvider";
import { deepSearch } from "../../helpers";
import { useQuery } from "@tanstack/react-query";
import { fetchMovies, fetchPopularMovies } from "../../api/moviesApi";
import { fetchPopularSeries, fetchSeries } from "../../api/seriesApi";
import Error from "../../components/Error";
import ContentContainer from "../../components/ContentContainer";

export default function Dashboard() {
  const { filterValue } = useSearchBarState();

  const {
    isLoading: seriesLoading,
    data: seriesData,
    error: seriesError,
  } = useQuery({
    queryKey: ["series"],
    queryFn: fetchSeries,
  });

  const {
    isLoading: popularSeriesLoading,
    data: popularSeriesData,
    error: popularSeriesError,
  } = useQuery({
    queryKey: ["popular-series"],
    queryFn: fetchPopularSeries,
  });

  const {
    isLoading: moviesLoading,
    data: moviesData,
    error: moviesError,
  } = useQuery({
    queryKey: ["movies"],
    queryFn: fetchMovies,
  });

  const {
    isLoading: popularMoviesLoading,
    data: popularMoviesData,
    error: popularMoviesError,
  } = useQuery({
    queryKey: ["popular-movies"],
    queryFn: fetchPopularMovies,
  });

  const filteredData = useMemo(
    () =>
      deepSearch(
        seriesData && moviesData
          ? [...seriesData, ...moviesData]
          : [],
        filterValue
      ),
    [filterValue, seriesData, moviesData]
  );

  if (seriesLoading || moviesLoading || popularMoviesLoading || popularSeriesLoading) {
    return <Loading />;
  }

  if (seriesError || moviesError || popularMoviesError || popularSeriesError) {
    return <Error errors={[seriesError, moviesError, popularMoviesError, popularSeriesError]} />;
  }

  return (
    <>
      {seriesData && moviesData && (
        <ContentContainer
          title="Trending"
          trends
          contents={[...popularSeriesData, ...popularMoviesData]}
        />
      )}
      {filteredData && (
        <div className="flex flex-col items-center">
          <ContentContainer
            title="Recommended for you"
            contents={filteredData}
          />
        </div>
      )}
    </>
  );
}
